import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';

import LocationsSelector from '$src/components/LocationsSelector/';
import './index.less';
import useStores from '$src/hooks/useStores';
import useFeature from '$src/hooks/useFeature';
import useLocationId from '$src/hooks/useLocationId';
import { COMPLETE } from '$src/components/LocationsSelector/Locations/constants';
import { redirectToDashboard, redirectToOnboardingIntroduction, redirectToSettings } from '$src/utils/redirect';
import { handleBackToRingDashboard } from '$src/utils/handleBack';

function Location() {
  const {
    locationStore: { fetchLocations, hasError, isFreeTrialEligible, locations, redirectToFreeTrial, setLocationId },
    sessionStore: { user, isMobile },
  } = useStores();
  const [isDashboardSmbCustomersEnabled] = useFeature('stark-feature-next-dashboard-smb-customers');
  const { search } = useLocation();

  const storedLocationId = useLocationId();

  if (hasError) {
    handleBackToRingDashboard(isMobile);
    return null;
  }

  const handleClick = ({ locationId, onboardStatus }) => {
    if (onboardStatus === COMPLETE) {
      redirectToSettings(locationId, search);
    } else {
      setLocationId(locationId);
      redirectToOnboardingIntroduction(locationId);
    }
  };

  if (isDashboardSmbCustomersEnabled){
    redirectToDashboard(true);
    return null;
  }

  // Fetch locations if it hasn't been done so far.
  if (user && locations === null)
    fetchLocations(user?.user_id);

  if (isFreeTrialEligible) {
    redirectToFreeTrial(storedLocationId);
    return null;
  }

  return <LocationsSelector handleClick={handleClick} data-testid="locations-page" />;
}

export default observer(Location);
